module.exports = __webpack_public_path__ + "static/img/aiBg.3de60994.png";